import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import {
  getHasResults,
  getSelectedFolder,
  getStudioParams,
} from '../../../selectors/studio';
import * as stash from '../../../selectors/stash';
import { AppState } from '../../../types/store';
import { Props } from './FolderHeaderDesktop';

export type StateProps = Pick<
  Props,
  | 'selectedFolder'
  | 'subfolders'
  | 'hasDeviations'
  | 'isVisitorView'
  | 'activeQuery'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const isVisitorStashView = stash.getIsVisitorView(state);
  const selectedFolder = isVisitorStashView
    ? stash.getStashFolder(state)!
    : getSelectedFolder(state)!;
  const hasDeviations = isVisitorStashView
    ? stash.getHasDeviations(state)
    : getHasResults(state);

  return {
    selectedFolder,
    hasDeviations,
    isVisitorView: isVisitorStashView,
    subfolders: stash.getSubfolders(state),
    activeQuery: getStudioParams(state).searchQuery,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
